import { useEffect, useState, } from "react";
import { Button, Modal, } from "react-bootstrap";
// import { formatVencimiento } from "../../../../utils/utils";
import { convenioService } from "../../../../_services/convenios.service";
import { planesDePagoService } from "../../../../_services/planesDePago.service";
import { fixNumber } from "../../../../utils/utils";

const SimulacionPlanPago = ({ show, handleClose, data }) => {
  // const [cuotas, setCuotas] = useState([]);
  const [plan, setPlan] = useState("");

  useEffect(() => {
    const getData = async () => {
      try {
        if (data.tipoPlan === "W2201") {          
          let deuda = await planesDePagoService.simDataPlanPago({
            rec: data.recurso,
            imp: data.imponible,
            cuotas: 1,
            plan: "W2201",
            jsdeuda: JSON.stringify(data.jsdeuda)
          });

          let intereses = data.jsdeuda.reduce((a,b) => +b?.INTERES + a, 0);
          let total = data.jsdeuda.reduce((a,b) => +b?.TOTAL + a, 0);
          let monto = fixNumber(total - (intereses * 0.20));
          let cuota = deuda.cuotas[0];

          setPlan(`
            <h5>Recurso: ${data.recurso.toUpperCase()} Imponible: ${data.imponible}. </h5>
            <br>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>CUOTA</th>
                  <th>VENCIMIENTO</th>
                  <th>VALOR</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>${cuota.CUOTA}</td>
                  <td>${cuota.VENC}</td>
                  <td>$ ${monto}</td>
                </tr>
              </tbody>
            </table>
            `);
        }  
        else if (data.tipoPlan === "W2200" || data.tipoPlan === "W2203") {         
          let deuda = await planesDePagoService.simDataPlanPago({
            rec: data.recurso,
            imp: data.imponible,
            cuotas: data.tipoPlan === "W2200" ? 4 : 7,
            plan: "ABLT",
            jsdeuda: JSON.stringify(data.jsdeuda)
          });

          let total = data.jsdeuda.reduce((a,b) => +b?.TOTAL + a, 0);
          let monto = fixNumber((total - +data.anticipo));

          setPlan(`
            <h5>Recurso: ${data.recurso.toUpperCase()} Imponible: ${data.imponible}. </h5>
            <br>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>CUOTA</th>
                  <th>VENCIMIENTO</th>
                  <th>VALOR</th>
                </tr>
              </thead>
              <tbody>
                ${deuda.cuotas.map((e, i) => {
    return (`
                   <tr>
                  <td>${e.CUOTA}</td>
                  <td>${e.VENC}</td>
                  <td>$ ${i === 0 ? fixNumber(+data.anticipo) :  fixNumber((monto / (data.tipoPlan === "W2200" ? 3 : 6)))}</td>
                </tr>
                `);
  })}
              </tbody>
            </table>
            `);
        } 
        else {
          const tipoCuotas = {
            W2113: 6,
            W2112: 3,
            W2201: 1,
            W2203: 7,
            "SHANT_6": 6,
            "SHANT_12": 12,
            SHCON: 1,
          };

          let body = {
            recurso: data.recurso,
            imponible: data.imponible,
            monto: data.total,
          };

          if(data.tipoPlan?.includes("SHANT")){
            body.plan = "SHANT";
            body.cuotas = tipoCuotas[data.tipoPlan];
          }
          else if (data.tipoPlan && data.tipoPlan !== "ABLT" && !data.tipoPlan?.includes("ABLT") && !data.tipoPlan?.includes("SHANT")) {
            body.plan = data.tipoPlan;
            body.cuotas = tipoCuotas[data.tipoPlan];
            // body.anticipo = +data.anticipo;
          }
          else if(data.tipoPlan === "ABLT" || data.tipoPlan?.includes("ABLT") || !data.tipoPlan){
            body.cuotas = +data.cuotas;
          }
          else if(data.tipoPlan?.includes("SHCON")){
            body.plan = "SHCON";
            body.cuotas = tipoCuotas[data.tipoPlan];
          }

          let response = await convenioService.simPlanPago(body);
          setPlan(response?.plan);
        }
      }
      catch (err) {
        console.log(err);
      }
    };

    getData();

  }, [data]);


  return (
    <Modal
      animation={false}
      show={show}
      onHide={handleClose}
      size="lg"
      centered
    >
      <Modal.Header>
        <Modal.Title>Simulación Plan de Pago</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          plan ? (
            data.total ? (
              <div dangerouslySetInnerHTML={{ __html: plan }} />
            ) : (
              <div className="d-flex justify-content-center mt-4 mb-4">
                <h5>
                  Debe seleccionar un monto de la deuda para simular un plan de pago.
                </h5>
              </div>
            )
          ) : (
            <div className="d-flex justify-content-center mt-4 mb-4">
              <h5>
                Cargando...
              </h5>
            </div>
          )
        }
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button onClick={handleClose} className="mr-3">
            Volver
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SimulacionPlanPago;